<template>
  <div @click="handleCloseSelect">
    <div class="selector-box">
      <div class="selector-left">
        <picker :data="country" :is-show="isShow" :is-en-expire="isEnExpire" :name="defaultName" :current.sync="current" @click.native="handleSelector" @handleTabItem="handleTabItem" :close-select.sync="closeSelect"/>
        <div style="width: 175px;">
          <datetime :start.sync="date" :defaultDate="defaultDate" :is-login="isPriceLogin" :selectedVariant="feedingMode === 'Grass-fed' ? 'success': 'warning'"/>
        </div>
      </div>
      <div class="selector-left">
        <selector :items="upsDowns" @tab-item="handleClickItem"/>
      </div>
    </div>
    <!--表格部分-->
    <div class="header">
      <div v-for="(item, index) in items" :key="index">
        <img class="" :src="item.icon">
        <span :class="{ 'ml-10': item.icon }">{{ item.label }}</span>
      </div>
    </div>
    <div class="table-box">
      <div v-for="(item, index) in tableListVisible" :key="index" class="table-item">
        <span>{{ item.OriginPlace }}</span>
        <span>{{ item.Part }}</span>
        <span @click="handleIsEnExpire">{{ item.ReferencePrice }}</span>
        <span v-if="item.CattleType !=''&& item.Level !=''&& item.FeedingDays !=0">{{item.CattleType}} {{ item.Level }} {{item.FeedingDays}}-day</span>
        <span v-else-if="item.CattleType ===''&& item.Level !=''&& item.FeedingDays !=0">{{item.CattleType}} {{ item.Level }} {{item.FeedingDays}}-day</span>
        <span v-else-if="item.CattleType ===''&& item.Level ===''">{{item.CattleType}}</span>
        <span v-else-if="item.CattleType !=''&& item.Level ===''">{{item.CattleType}}</span>
        <span v-else-if="item.CattleType !=''&& item.Level !=''&& item.FeedingDays ===0">{{item.CattleType}} {{ item.Level }}</span>
        <span v-else-if="item.CattleType ===''&& item.Level !=''&& item.FeedingDays ===0">{{ item.Level }}</span>
        <span v-else-if="item.Level ===''&& item.FeedingDays !=0">{{ item.FeedingDays }}-day</span>
        <span @click="handleIsEnExpire">
          <span class="trend" :class="[item.Rise < 0 ? 'trend-green'  : ( item.Rise==0? 'trend-grey' : 'trend-red')]">{{ item.RiseRate }}</span>
        </span>
        <span>
           <img v-if="item.Rise < 0" class="hand" src="@/assets/image/price/tread-green.png" style="width: 50px; height: 21px;" @click="handleTread(item, 2)">
           <img v-else class="hand" src="@/assets/image/price/tread-red.png" style="width: 50px; height: 21px;" @click="handleTread(item, 1)">
        </span>
      </div>
    </div>
    <b-modal id="UpsAndDownsSpotModal" v-model="modalShow" size="lg" button-size="sm" :title="listQuery.Country + ' - ' +listQuery.Part">
      <div class="item-box">
        <modal-chart v-if="list" :key="keyIndex" ref="UpsAndDownsSpotTableChart" :data="list" :color="chartColor" :legend="{}"/>
      </div>
    </b-modal >
  </div>
</template>
<script>
import Datetime from './components/selector-datetime'
import Picker from '@/views/en/btcprice/components/table/components/picker'
import Selector from '@/views/en/btcprice/components/table/components/selector'
import ModalChart from '../chart/index'
import { getCountry, getSeries, sorting } from '@/views/en/btcprice/utils'
import commonmix from '@/utils/commonmix'
import { getLocalStore } from '@/utils/common'

export default {
  mixins: [commonmix],
  name: 'UpsAndDownsSpotTable',
  components: {
    Selector,
    Datetime,
    Picker,
    ModalChart
  },
  props: {
    feedingMode: {
      type: String,
      default: () => ''
    },
    tableList: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    defaultDate: {
      type: Array,
      default: () => []
    },
    isSwitchNavBar: {
      type: Boolean,
      default: false
    },
    isEnExpire: {
      type: Boolean,
      default: false
    },
    isPriceLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    country () {
      return getCountry()
    },
    isSwitchNavBarVisible: {
      get () {
        return this.isSwitchNavBar
      },
      set (val) {
        this.$emit('update:isSwitchNavBar', val)
      }
    },
    tableListVisible: {
      get () {
        const list = this.tableList
        sorting(list, 'Rise', this.sortingType)

        return list
      },
      set (val) {
        this.$emit('update:tableList', val)
      }
    }
  },
  watch: {
    isSwitchNavBarVisible (val) {
      if (val) {
        // 切换了TabBar
        this.defaultCountry = 'All'
        this.defaultCuts = 'All'
        this.defaultName = 'Country'
        this.current = 0
        this.listQuery.FeedingMode = this.feedingMode
        this.closeSelect = true

        this.isSwitchNavBarVisible = false
      }
    },
    date (val) {
      this.$emit('handleDate', val)
    },
    closeSelect (val) {
      if (val) {
        this.isShow = false
        this.closeSelect = false
      }
    }
  },
  data () {
    return {
      upsDowns: [
        { label: 'Ups', value: '_ups' },
        { label: 'Downs', value: '_downs' }
      ],
      listQuery: {
        UserID: getLocalStore().UserID,
        Part: 'Flank 80vl',
        Country: 'Brazil',
        RecommendDay: 0,
        FeedingMode: 'Grass-fed',
        Type: '_spotgoods',
        IsFirst: true,
        IsEn: true
      },
      chartColor: {},
      defaultCountry: 'All',
      defaultName: 'Country',
      sortingType: '_ups',
      date: this.defaultDate[0],
      list: null,
      modalShow: false,
      current: 0,
      keyIndex: 0,
      closeSelect: false,
      isShow: false
    }
  },
  methods: {
    getData () {
      this.$store.dispatch('GetWebPriceDataIndex', this.listQuery).then(() => {
        const row = this.$store.getters.priceRow
        this.list = { categories: row.categories, series: getSeries(row.series) }
        if (this.$refs.UpsAndDownsSpotTableChart) {
          this.$refs.UpsAndDownsSpotTableChart.refreshData({ categories: row.categories, series: getSeries(row.series) })
        }
        this.keyIndex++
      }).catch((err) => {
        console.error(err)
      })
    },
    handleTabItem (item) {
      this.defaultName = item
      this.defaultCountry = item
      this.$emit('handlePicker', {
        OriginPlace: this.defaultCountry
      })
    },
    handleClickItem (item) {
      this.sortingType = item.value
      sorting(this.tableListVisible, 'Rise', item.value)
    },
    handleTread (item, type) {
      if (this.$store.getters.token) {
        const firstItem = this.sortingType === '_ups' ? this.tableList[0] : this.tableList[this.tableList.length - 1]
        if (this.isEnExpire || item === firstItem) {
          if (type === 1) {
            this.chartColor = { Color1: '#c10b0b', Color2: '#FFFFFF' }
          } else {
            this.chartColor = { Color1: '#2b915c', Color2: '#FFFFFF' }
          }
          this.listQuery.Part = item.Part
          this.listQuery.Country = item.OriginPlace

          this.getData()
          this.modalShow = !this.modalShow
        } else {
          this.openMembershipModal()
        }
      } else {
        this.openLoginModal()
      }
    },
    handleCloseSelect () {
      this.closeSelect = true
    },
    handleSelector () {
      this.isShow = !this.isShow
    },
    handleIsEnExpire () {
      if (this.$store.getters.token) {
        if (!this.isEnExpire) {
          this.openMembershipModal()
        }
      } else {
        this.openLoginModal()
      }
    }
  }
}
</script>

<style>
#UpsAndDownsSpotModal .modal-dialog{
  top: 28%;
  left: 4.5%;
}

@media screen and (min-width: 2048px) {
  #UpsAndDownsSpotModal .modal-dialog{
    top: 20%;
    left: 4.5%;
  }
}

#UpsAndDownsSpotModal .modal-title{
  flex: 1;
  text-align: center;
  font-size: 18px;
}

#UpsAndDownsSpotModal .modal-footer{
  display: none;
}
</style>

<style lang="scss" scoped>
$cell-width: 150px;
$cell-green: #2b915c;
$cell-red: #c10b0b;

.selector-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px;
}

.selector-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.point {
  text-align: center;
  margin: 0 10px;
  height: 3px;
  content: " ";
  border: 3px solid;
  border-radius: 3px;
}

.lower-height {
  font-size: 12px;
}

.trend {
  width: 50px;
  height: 20px;
  color: #ffffff;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 14px;
}

.trend-green {
  background-color: $cell-green;
}

.trend-red {
  background-color: $cell-red;
}

.trend-grey {
  background-color: #808080;
}

// 表头
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
}

.header > div {
  min-width: $cell-width;
  text-align: center;
}

.ml-10 {
  margin-left: 10px;
}

.table-box {
  margin-top: 10px;
  height: 840px;
  overflow-y: scroll;
}

.table-item {
  height: 35px;
  border-radius: 8px;
  background: #f1f2f3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 5px 0;
}

.table-item > span {
  width: $cell-width;
  text-align: center;
  font-size: 14px;
}
</style>
